var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.718,
    height: 17.047,
    viewBox: "0 0 10.718 17.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37886",
    "data-name": "Group 37886",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27734",
    "data-name": "Path 27734",
    d: "M16.694,19.07a13,13,0,0,0-2.659-.843,14.533,14.533,0,0,1-1.873-.562,2.416,2.416,0,0,1-.936-.6,1.236,1.236,0,0,1-.3-.843,1.292,1.292,0,0,1,.581-1.142,2.884,2.884,0,0,1,1.629-.393,2.847,2.847,0,0,1,1.554.393,1.517,1.517,0,0,1,.749,1.011.543.543,0,0,0,.543.337h1.779a.375.375,0,0,0,.393-.393,2.978,2.978,0,0,0-.487-1.423,4.158,4.158,0,0,0-1.33-1.292,5.169,5.169,0,0,0-2.1-.73V11.26a.412.412,0,0,0-.449-.449H12.63a.449.449,0,0,0-.318.112.431.431,0,0,0-.131.318v1.292A4.926,4.926,0,0,0,9.3,13.77a3.3,3.3,0,0,0-1.049,2.472A3.053,3.053,0,0,0,9.3,18.658a7.978,7.978,0,0,0,3.24,1.386,20.7,20.7,0,0,1,2,.618,2.809,2.809,0,0,1,1.011.581,1.142,1.142,0,0,1,.337.843,1.367,1.367,0,0,1-.656,1.2,3.558,3.558,0,0,1-1.873.449,3.334,3.334,0,0,1-1.873-.431,2,2,0,0,1-.9-.9.88.88,0,0,0-.225-.281.6.6,0,0,0-.356,0H8.322a.393.393,0,0,0-.3.112.375.375,0,0,0-.112.281,3.165,3.165,0,0,0,.543,1.629,3.933,3.933,0,0,0,1.461,1.292,6.031,6.031,0,0,0,2.3.656V27.4a.431.431,0,0,0,.131.337.449.449,0,0,0,.318.112h1.161a.412.412,0,0,0,.449-.449V26.093a5.619,5.619,0,0,0,3.165-1.386,3.315,3.315,0,0,0,1.18-2.641,3.24,3.24,0,0,0-.468-1.873,3.446,3.446,0,0,0-1.461-1.124Z",
    transform: "translate(-7.91 -10.809)",
    fill: "#16346c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.b9582222f6057db1c2fa5a83086863a2.svg";
export { ForwardRef as ReactComponent };